export const getShouldShowMetamask = () => {
  const pathname = window?.location?.pathname;
  return pathname?.includes('bridge') || pathname?.includes('stake');
};
